import React from 'react';
import { getModuleCategories, getModuleFieldsBeta } from '../../api/modules';
import useAsync from '../../hooks/useAsync';
import {
	TemplateDate,
	TemplateDropdown,
} from '../../components/Attributes/Attributes_old';
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline';

const SERVICE_MODULE_ID = process.env.REACT_APP_MODULE_ID_SERVICE;
const EVENT_MODULE_ID = process.env.REACT_APP_MODULE_ID_EVENT;

const ContractTasks = ({ taskForm, setTaskForm, updatedForm }) => {
	console.log('SERVICE_MODULE_ID: ', SERVICE_MODULE_ID);
	const { value: taskModuleFields, status: isLoadingTaskModuleFields } =
		useAsync(getModuleFieldsBeta, {
			defaultPayload: { id: SERVICE_MODULE_ID, active: true },
		});

	const {
		value: eventCategories,
		execute: onRefreshEventCategories,
		status: isLoadingEventCategories,
	} = useAsync(getModuleCategories, {
		defaultPayload: { id: EVENT_MODULE_ID },
	});

	const OCCURRENCES_OPTIONS =
		taskModuleFields?.standard?.find(
			(field) => field?.isDefault && field?.key === 'occurrences'
		)?.options?.options || [];

	return (
		<>
			<div className="col-span-2 space-y-4">
				{eventCategories
					?.filter(
						(category) =>
							category?.key !== 'default:repair' && category?.isDefault
					)
					.map((category) => (
						<div className="flex">
							<div className="flex-1 text-xs ml-2 mt-3">{category?.name}</div>
							<div className="min-w-56">
								<div className="col-span-2 flex h-fit">
									<div className="flex-1">
										<TemplateDropdown
											className=""
											options={[
												{ label: 'None', key: null },
												...OCCURRENCES_OPTIONS,
											]}
											value={taskForm[category?.id]?.value}
											onChange={(index, value, fullValue) => {
												setTaskForm({
													...taskForm,
													[category?.id]: {
														...fullValue,
														category,
													},
												});
											}}
										/>
									</div>
									{taskForm[category?.id]?.value === 'custom' && (
										<div className="flex-shrink flex items-center pt-1.5 ml-3">
											<PlusCircleIcon
												className="w-6 h-6 cursor-pointer text-gray-500"
												onClick={() =>
													setTaskForm({
														...taskForm,
														[category?.id]: {
															...taskForm[category?.id],
															dates: [
																...(taskForm[category?.id]?.dates || []),
																null,
															],
														},
													})
												}
											/>
										</div>
									)}
								</div>

								{taskForm[category?.id]?.value === 'custom' &&
								taskForm[category?.id]?.dates?.length
									? taskForm[category?.id]?.dates
											?.sort((a, b) => a?.getTime() - b?.getTime())
											.map((date, dateIdx) => (
												<>
													<div className="col-span-2 flex h-fit mt-2">
														<div className="flex-1">
															<TemplateDate
																minDate={updatedForm['coverage-start']?.value}
																maxDate={updatedForm['coverage-end']?.value}
																value={date}
																onChange={(index, newDate) => {
																	let oldDates = taskForm[category?.id].dates;
																	oldDates[dateIdx] = newDate;
																	setTaskForm({
																		...taskForm,
																		[category?.id]: {
																			...taskForm[category?.id],
																			dates: oldDates,
																		},
																	});
																}}
															/>
														</div>
														<div className="flex-shrink flex items-center pt-1.5 ml-3">
															<MinusCircleIcon
																className="w-6 h-6 cursor-pointer text-gray-500"
																onClick={() => {
																	setTaskForm({
																		...taskForm,
																		[category?.id]: {
																			...taskForm[category?.id],
																			dates: taskForm[
																				category?.id
																			].dates?.filter(
																				(d, dIdx) => dIdx !== dateIdx
																			),
																		},
																	});
																}}
															/>
														</div>
													</div>
												</>
											))
									: null}
							</div>
						</div>
					))}

				{eventCategories?.filter(
					(category) =>
						category?.key !== 'default:repair' && !category?.isDefault
				)?.length ? (
					<div className="flex items-center">
						<div className=" text-xs text-gray-400 mr-2 pl-2 my-3">
							Custom Categories
						</div>
						<div className="flex-1 my-2 border-b border-gray-100"></div>
					</div>
				) : null}
				{eventCategories
					?.filter(
						(category) =>
							category?.key !== 'default:repair' && !category?.isDefault
					)
					.map((category) => (
						<div className="flex">
							<div className="flex-1 text-xs ml-2 mt-3">{category?.name}</div>
							<div className="min-w-56">
								<div className="col-span-2 flex h-fit">
									<div className="flex-1">
										<TemplateDropdown
											className=""
											options={[
												{ label: 'None', key: null },
												...OCCURRENCES_OPTIONS,
											]}
											value={taskForm[category?.id]?.value}
											onChange={(index, value, fullValue) => {
												setTaskForm({
													...taskForm,
													[category?.id]: {
														...fullValue,
														category,
													},
												});
											}}
										/>
									</div>
									{taskForm[category?.id]?.value === 'custom' && (
										<div className="flex-shrink flex items-center pt-1.5 ml-3">
											<PlusCircleIcon
												className="w-6 h-6 cursor-pointer text-gray-500"
												onClick={() =>
													setTaskForm({
														...taskForm,
														[category?.id]: {
															...taskForm[category?.id],
															dates: [
																...(taskForm[category?.id]?.dates || []),
																null,
															],
														},
													})
												}
											/>
										</div>
									)}
								</div>

								{taskForm[category?.id]?.value === 'custom' &&
								taskForm[category?.id]?.dates?.length
									? taskForm[category?.id]?.dates
											?.sort((a, b) => a?.getTime() - b?.getTime())
											.map((date, dateIdx) => (
												<>
													<div className="col-span-2 flex h-fit mt-2">
														<div className="flex-1">
															<TemplateDate
																minDate={updatedForm['coverage-start']?.value}
																maxDate={updatedForm['coverage-end']?.value}
																value={date}
																onChange={(index, newDate) => {
																	let oldDates = taskForm[category?.id].dates;
																	oldDates[dateIdx] = newDate;
																	setTaskForm({
																		...taskForm,
																		[category?.id]: {
																			...taskForm[category?.id],
																			dates: oldDates,
																		},
																	});
																}}
															/>
														</div>
														<div className="flex-shrink flex items-center pt-1.5 ml-3">
															<MinusCircleIcon
																className="w-6 h-6 cursor-pointer text-gray-500"
																onClick={() => {
																	setTaskForm({
																		...taskForm,
																		[category?.id]: {
																			...taskForm[category?.id],
																			dates: taskForm[
																				category?.id
																			].dates?.filter(
																				(d, dIdx) => dIdx !== dateIdx
																			),
																		},
																	});
																}}
															/>
														</div>
													</div>
												</>
											))
									: null}
							</div>
						</div>
					))}
			</div>
		</>
	);
};

export default ContractTasks;
